import type { ContractReview, ContractReviewAttachment } from '~/components/contractReview/types';

/**
 * The contract itself, out of everything attached to it: the one flagged primary, or the
 * earliest upload when nothing is flagged — an older contract may predate the flag.
 *
 * ContractIQ reports are excluded whatever their flags: they are output about the
 * contract, not the agreement the page is showing.
 */
export const getPrimaryDocument = (
  contract: ContractReview | null,
): ContractReviewAttachment | undefined => {
  const uploads = (contract?.attachments ?? []).filter(
    (attachment) => attachment.kind !== 'cfi_report' && attachment.attachmentUrl,
  );

  return uploads.find((attachment) => attachment.isPrimary) ?? uploads[0];
};
